import { render, staticRenderFns } from "./Resales.vue?vue&type=template&id=4589657a&scoped=true"
import script from "./Resales.vue?vue&type=script&lang=js"
export * from "./Resales.vue?vue&type=script&lang=js"
import style0 from "./Resales.vue?vue&type=style&index=0&id=4589657a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589657a",
  null
  
)

export default component.exports